export default {"src":"/accounts/_next/static/media/DownloadIcon.ce2a392c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};